export const printSizeList = [
  { value: '', id: 'free' },
  { value: 'A4', id: 'A4' },
  { value: 'B4', id: 'B4' },
  { value: 'A3', id: 'A3' },
  { value: 'A2', id: 'A2' },
  { value: 'A1', id: 'A1' },
]
